import React from "react";

export function PageHeader({ overline, title, children, testid }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 border-b border-[#E5E7EB] pb-6 mb-8" data-testid={testid || "page-header"}>
      <div>
        <div className="overline mb-2">{overline}</div>
        <h1 className="font-display text-4xl font-bold tracking-tighter text-[#0F172A]">{title}</h1>
      </div>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
    </div>
  );
}
